module.exports = __webpack_public_path__ + "pic/0.43ca3d19.png";